import React from "react"

import {
  people_bool_exp,
  projects_bool_exp,
} from "../__generated__/PlannerContainerQuery.graphql"

export type FilteredPlannerContextData = {
  projectIDs: number[]
  peopleIDs: number[]
  totalProjectCount: number
  totalPeopleCount: number
  temporaryProjectFilters: projects_bool_exp | null
  temporaryPeopleFilters: people_bool_exp | null
}

const FilteredPlannerContext = React.createContext<FilteredPlannerContextData>({
  projectIDs: [],
  peopleIDs: [],
  totalProjectCount: 0,
  totalPeopleCount: 0,
  temporaryProjectFilters: null,
  temporaryPeopleFilters: null,
})

export default FilteredPlannerContext
